
const constants =  {
    SUCCESS:"SUCCESS",
    ERROR:"ERROR",
    CLEAR:"CLEAR",
    INFO:"INFO"
}

export default constants;